(() => {
  window.wheelSettings = function wheelSettings() {
    return {
      soundEnabled: localStorage.getItem("wheelSoundEnabled") !== "false",
      init() {
        window.soundEnabled = this.soundEnabled;
      },
      toggleSound() {
        this.soundEnabled = !this.soundEnabled;
        localStorage.setItem("wheelSoundEnabled", String(this.soundEnabled));
        window.soundEnabled = this.soundEnabled;
      },
    };
  };

  window.wheelAnimation = function wheelAnimation() {
    return {
      isAnimating: false,
      currentPosition: 0,
      slotWidth: 135,
      currentCenterSlot: null,
      _raf: null,
      _pendingComplete: null,
      _pendingProductId: null,
      _tweenMain: null,
      _tweenInertia: null,
      slotsCache: null,
      isInitialized: false,

      init() {
        this.$nextTick(() => {
          this.updateSlotWidth();
          this.refreshSlots();
          this.rebuildSlots(3, true);
          this.centerInitialSlot();
          this.updateCenterScale();
          this.isInitialized = true;
        });
      },

      refreshSlots() {
        this.slotsCache = Array.from(this.$refs.slotContainer.querySelectorAll(".slot"));
        return this.slotsCache;
      },

      rebuildSlots(count, shuffleBase) {
        if (!this.$refs.slotContainer) return;
        const totalSlots = this.getTotalSlots() || 1;
        if (totalSlots <= 0) return;

        const allSlots = Array.from(this.$refs.slotContainer.querySelectorAll(".slot"));
        if (allSlots.length < totalSlots) return;

        const baseSlots = allSlots.slice(0, totalSlots);

        if (shuffleBase) {
          for (let i = baseSlots.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const tmp = baseSlots[i];
            baseSlots[i] = baseSlots[j];
            baseSlots[j] = tmp;
          }
        }

        this.$refs.slotContainer.innerHTML = "";
        const frag = document.createDocumentFragment();
        baseSlots.forEach((slot) => frag.appendChild(slot));
        for (let i = 1; i < count; i++) {
          baseSlots.forEach((slot) => frag.appendChild(slot.cloneNode(true)));
        }
        this.$refs.slotContainer.appendChild(frag);
        this.slotsCache = Array.from(this.$refs.slotContainer.querySelectorAll(".slot"));
      },

      getTotalSlots() {
        const value = parseInt(this.$refs.slotContainer?.dataset.totalSlots || "0", 10);
        return value > 0 ? value : 0;
      },

      updateSlotWidth() {
        const firstSlot = this.$refs.slotContainer?.querySelector(".slot");
        if (firstSlot) {
          const rect = firstSlot.getBoundingClientRect();
          this.slotWidth = rect.width || 135;
          if (!this.slotsCache || this.slotsCache.length === 0) this.refreshSlots();
        } else {
          this.slotWidth = 135;
        }
      },

      centerInitialSlot() {
        this.refreshSlots();
        this.updateSlotWidth();

        const totalSlots = this.getTotalSlots() || 1;
        const allSlotsCount = this.slotsCache ? this.slotsCache.length : totalSlots * 3;
        const containerWidth = allSlotsCount * this.slotWidth;

        const centerSlotIndex = 6;
        const slotCenterFromLeft = centerSlotIndex * this.slotWidth + this.slotWidth / 2;
        const translateX = containerWidth / 2 - slotCenterFromLeft;

        this.currentPosition = translateX;
        this.$refs.slotContainer.style.setProperty("--wheel-translate-x", `${translateX}px`);
      },

      findSlotByProductId(productId) {
        if (!productId) return null;
        const slots = this.slotsCache || this.refreshSlots();
        const totalSlots = this.getTotalSlots() || 1;
        const set2Start = totalSlots;
        const set2End = totalSlots * 2;

        for (let i = set2Start; i < set2End && i < slots.length; i++) {
          const slotProductId =
            slots[i].getAttribute("data-productid") || slots[i].getAttribute("data-productId");
          if (slotProductId && String(slotProductId) === String(productId)) return i;
        }
        return null;
      },

      startCenterWatcher() {
        this.stopCenterWatcher();
        let lastUpdateTime = 0;
        const updateInterval = 100;

        const tick = () => {
          if (!this.isAnimating) return;
          const now = performance.now();
          if (now - lastUpdateTime >= updateInterval) {
            this.updateCenterScale();
            lastUpdateTime = now;
          }
          this._raf = requestAnimationFrame(tick);
        };
        this._raf = requestAnimationFrame(tick);
      },

      stopCenterWatcher() {
        if (this._raf) {
          cancelAnimationFrame(this._raf);
          this._raf = null;
        }
      },

      updateCenterScale() {
        const slots = this.slotsCache;
        if (!slots || !slots.length) return;

        const containerWidth = slots.length * this.slotWidth;
        const rawIndex = Math.round((containerWidth / 2 - this.currentPosition) / this.slotWidth - 0.5);
        const actualIndex = Math.max(0, Math.min(rawIndex, slots.length - 1));
        const closestSlot = slots[actualIndex];

        if (closestSlot && this.currentCenterSlot !== closestSlot) {
          if (this.currentCenterSlot) this.currentCenterSlot.classList.remove("center-scale");
          closestSlot.classList.add("center-scale");

          if (window.soundEnabled && window.TestAudioManager) {
            window.TestAudioManager.play("tick");
          }

          this.currentCenterSlot = closestSlot;
        }
      },

      getCenterSlotElement() {
        const slots = this.slotsCache || this.refreshSlots();
        const containerWidth = slots.length * this.slotWidth;
        const centerIndex = Math.round((containerWidth / 2 - this.currentPosition) / this.slotWidth - 0.5);
        if (centerIndex >= 0 && centerIndex < slots.length) return slots[centerIndex];
        return this.currentCenterSlot || null;
      },

      async spinToIndex(productId, totalDuration = 4.7, onComplete) {
        if (this.isAnimating) return;
        if (!this.$refs.slotContainer || typeof window.gsap === "undefined") return;

        this.isAnimating = true;
        this.$refs.wheelContainer.classList.add("spinning");
        this.startCenterWatcher();
        this._pendingComplete = onComplete || null;
        this._pendingProductId = productId;

        this.rebuildSlots(3, true);
        this.updateSlotWidth();

        const totalSlots = this.getTotalSlots() || 1;
        const allSlotsCount = this.slotsCache ? this.slotsCache.length : totalSlots * 3;
        const containerWidth = allSlotsCount * this.slotWidth;

        const startSlotIndex = 6;
        const slotCenterFromLeft = startSlotIndex * this.slotWidth + this.slotWidth / 2;
        const startPosition = containerWidth / 2 - slotCenterFromLeft;

        this.currentPosition = startPosition;
        this.$refs.slotContainer.style.setProperty("--wheel-translate-x", `${startPosition}px`);

        const targetDomIndex = this.findSlotByProductId(productId);
        if (targetDomIndex === null) {
          this.stopCenterWatcher();
          this.isAnimating = false;
          this.$refs.wheelContainer.classList.remove("spinning");
          return;
        }

        const speedMultiplier = 0.9 + Math.random() * 0.2;
        const spinDuration = Math.min(5.5, totalDuration * speedMultiplier);

        const targetSlotCenter = targetDomIndex * this.slotWidth + this.slotWidth / 2;
        const baseTargetPosition = containerWidth / 2 - targetSlotCenter;

        const inertiaAmount = (0.15 + Math.random() * 0.1) * this.slotWidth;
        const isOvershoot = Math.random() > 0.5;
        const stopBeforeTarget = isOvershoot ? baseTargetPosition - inertiaAmount : baseTargetPosition + inertiaAmount;

        const inertiaDuration = 1.2;

        if (window.CustomEase && !window.__wheelEase) {
          window.__wheelEase = CustomEase.create("wheelEase", "0.05,0,0.2,1");
        }

        if (this._tweenMain) this._tweenMain.kill();
        if (this._tweenInertia) this._tweenInertia.kill();

        const state = { value: startPosition };

        this._tweenMain = window.gsap.to(state, {
          value: stopBeforeTarget,
          duration: spinDuration,
          ease: window.__wheelEase ? "wheelEase" : "power4.out",
          onUpdate: () => {
            this.currentPosition = state.value;
            this.$refs.slotContainer.style.setProperty("--wheel-translate-x", `${state.value}px`);
          },
          onComplete: () => {
            this._tweenInertia = window.gsap.to(state, {
              value: baseTargetPosition,
              duration: inertiaDuration,
              ease: "power1.out",
              onUpdate: () => {
                this.currentPosition = state.value;
                this.$refs.slotContainer.style.setProperty("--wheel-translate-x", `${state.value}px`);
              },
              onComplete: () => {
                this.currentPosition = baseTargetPosition;
                this.$refs.slotContainer.style.setProperty("--wheel-translate-x", `${baseTargetPosition}px`);
                this.updateCenterScale();
                this.stopCenterWatcher();

                if (this._pendingComplete && typeof this._pendingComplete === "function") {
                  this._pendingComplete();
                }

                this._pendingComplete = null;
                this._pendingProductId = null;
                this.isAnimating = false;
                this.$refs.wheelContainer.classList.remove("spinning");
              },
            });
          },
        });
      },
    };
  };

  const cfg = window.MagicWheelTest || {};
  const SOUND = cfg.sounds || {};

  window.TestAudioManager = {
    ctx: null,
    buffers: {},
    gainNodes: {},
    sources: {},

    async init() {
      if (this.ctx) return;
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;

      this.ctx = new AC();

      await Promise.all([
        this.load("start", SOUND.start, 0.7),
        this.load("tick", SOUND.tick, 0.5),
        this.load("finish", SOUND.finish, 0.7),
      ]);
    },

    async load(name, url, volume = 1) {
      if (!url) return;
      try {
        const res = await fetch(url, { cache: "force-cache" });
        if (!res.ok) throw new Error(`${name} fetch failed: ${res.status}`);
        const arr = await res.arrayBuffer();

        this.buffers[name] = await this.ctx.decodeAudioData(arr);

        const g = this.ctx.createGain();
        g.gain.value = volume;
        g.connect(this.ctx.destination);
        this.gainNodes[name] = g;
      } catch (e) {
        console.warn("[TestAudioManager] load error:", name, url, e);
      }
    },

    async resumeIfNeeded() {
      if (!this.ctx) return;
      if (this.ctx.state === "suspended") {
        try { await this.ctx.resume(); } catch (_) {}
      }
    },

    async play(name) {
      if (localStorage.getItem("wheelSoundEnabled") === "false") return;
      if (!this.ctx || !this.buffers[name] || !this.gainNodes[name]) return;

      await this.resumeIfNeeded();

      if (this.sources[name]) {
        try { this.sources[name].stop(0); } catch (_) {}
        this.sources[name] = null;
      }

      const src = this.ctx.createBufferSource();
      src.buffer = this.buffers[name];
      src.connect(this.gainNodes[name]);
      src.start(0);
      this.sources[name] = src;
    },
  };

  function clearPrizeUI() {
    document.querySelectorAll("#slotContainer .win-slot").forEach((el) => el.classList.remove("win-slot"));
    document.querySelectorAll("#slotContainer .js-wheel-slot-info").forEach((el) => el.remove());
  }

  function showPrizeInfoFromSlot(slotEl) {
    if (!slotEl) return;

    clearPrizeUI();

    const box = slotEl.querySelector(".slot-container-box");
    if (box) box.classList.add("win-slot");

    const title = slotEl.getAttribute("data-title") || "";
    const vendor = slotEl.getAttribute("data-vendor") || "";
    const price = slotEl.getAttribute("data-price") || "";

    const imgContainer = slotEl.querySelector(".img-container");
    if (!imgContainer) return;

    imgContainer.insertAdjacentHTML(
      "afterend",
      `<div class="slot-info js-wheel-slot-info">
        <div class="slot-title">${title}</div>
        <div class="slot-vendor">${vendor}</div>
        <div class="slot-container-price box-price-wrap">
          <p class="price">${price}</p>
        </div>
      </div>`
    );

    const inserted = imgContainer.nextElementSibling;
    if (inserted && inserted.classList.contains("js-wheel-slot-info")) {
      requestAnimationFrame(() => inserted.classList.add("is-visible"));
    }
  }

  function getAlpineComponent(el) {
    try {
      if (window.Alpine && typeof window.Alpine.$data === "function") return window.Alpine.$data(el);
      if (typeof Alpine !== "undefined" && typeof Alpine.$data === "function") return Alpine.$data(el);
    } catch (_) {}
    return null;
  }

  async function waitForGSAP(timeoutMs = 4000) {
    const t0 = Date.now();
    while (typeof window.gsap === "undefined") {
      if (Date.now() - t0 > timeoutMs) return false;
      await new Promise((r) => setTimeout(r, 50));
    }
    return true;
  }

  document.addEventListener("DOMContentLoaded", () => {
    const cfg = window.MagicWheelTest || {};
    const SEL = cfg.selectors || {};
    const TXT = cfg.text || {};
    const spinButton = document.querySelector(SEL.spinButton || "#spinButton");
    const wheelContainer = document.querySelector(SEL.wheelContainer || ".wheel-container");

    if (!spinButton || !wheelContainer) return;

    function getAlpineComponent(el) {
      try {
        if (window.Alpine && typeof window.Alpine.$data === "function") return window.Alpine.$data(el);
        if (typeof Alpine !== "undefined" && typeof Alpine.$data === "function") return Alpine.$data(el);
      } catch (e) {}
      return null;
    }

    spinButton.addEventListener("click", async (e) => {
      e.preventDefault();
      if (spinButton.disabled) return;

      const span = spinButton.querySelector("span");
      const originalText = span ? span.textContent : "";
      const setBtnText = (t) => { if (span) span.textContent = t; };

      spinButton.disabled = true;
      spinButton.classList.add("is-loading");
      setBtnText((TXT.spinning || "Spinning..."));

      let doneOnce = false;

      try {
        if (window.TestAudioManager && !window.TestAudioManager.ctx) {
          await window.TestAudioManager.init();
        }

        const alpineComponent = getAlpineComponent(wheelContainer);
        if (!alpineComponent || !alpineComponent.$refs?.slotContainer) return;

        const totalSlots = parseInt(alpineComponent.$refs.slotContainer.dataset.totalSlots || "0", 10) || 0;
        const baseSlots = Array.from(alpineComponent.$refs.slotContainer.querySelectorAll(".slot")).slice(0, totalSlots);
        if (!baseSlots.length) return;

        const randomSlot = baseSlots[Math.floor(Math.random() * baseSlots.length)];
        const winningProductId = randomSlot.getAttribute("data-productId") || randomSlot.getAttribute("data-productid");

        clearPrizeUI();
        window.TestAudioManager?.play?.("start");

        await new Promise((resolve) => {
          const done = () => {
            if (doneOnce) return;
            doneOnce = true;

            setBtnText(originalText);

            const centerSlot = alpineComponent.getCenterSlotElement?.();
            if (centerSlot) showPrizeInfoFromSlot(centerSlot);
            
            window.TestAudioManager?.play?.("finish");
            
            resolve();
          };

          alpineComponent.spinToIndex(winningProductId, 4.7, done);
          setTimeout(done, 9000);
        });

      } finally {
        spinButton.disabled = false;
        spinButton.classList.remove("is-loading");
        setBtnText(originalText);
      }
    });
  });
})();